export default __webpack_public_path__ + "static/media/arc-logo.84bca8bc.png";